export default "__VITE_ASSET__DThrDYKQ__"